import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Requirements by Assignee',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: '',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Requirements',
                          points: {
                            '@': 'assigneePoints',
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Assignee',
                  yLabel: 'Requirements',
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    assigneePoints: {
      filter: {
        '>': [
          {
            '#': {
              '@': 'assignedRequirements',
            },
          },
          0,
        ],
      },
      sort: {
        by: {
          '#': {
            '@': 'assignedRequirements',
          },
        },
        descending: true,
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '{}': {
          x: {
            '@.': '!name',
          },
          y: {
            '#': {
              '@': 'assignedRequirements',
            },
          },
          onClick: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {
                              jiraStatusFilter: null,
                              typeFilter: null,
                              assigneeFilter: {
                                '@.': '!id',
                              },
                              dueDateFilter: null,
                            },
                          },
                          navigationId: 'requirements-dashboard',
                        },
                      },
                    },
                  },
                  operation: 'ui.navigate',
                },
              },
            },
          },
        },
      },
      subqueries: {
        assignedRequirements: {
          filter: {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          ref: {
            attr: 'attr:ent#!requirements#!requirement:!assignee',
          },
          target: 'ent:!requirements:!requirement',
          selection: {
            '@.': '!id',
          },
          subqueries: {
            specProject: {
              ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
              target: 'ent:!specs:!spec',
              selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
            },
          },
        },
      },
    },
  },
}
